import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { t } from "i18next";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";

export type EllipsesMenuNutritionDialogProps = {
  onSelect?: () => void;
  onBreakFast?: () => void;
  onMediaMana?: () => void;
  onLunch?: () => void;
  onSnack?: () => void;
  onDinner?: () => void;
  onPoscena?: () => void;
};

const EllipsesMenuNutritionDialog: React.FC<
  EllipsesMenuNutritionDialogProps
> = ({
  onSelect,
  onBreakFast,
  onMediaMana,
  onLunch,
  onSnack,
  onDinner,
  onPoscena,
}) => {
  return (
    <Menu as="div" className="relative flex-none">
      <MenuButton className="block p-2 text-gray-500 hover:text-gray-900">
        <span className="sr-only">Open options</span>
        <EllipsisVerticalIcon aria-hidden="true" className="h-6 w-6" />
      </MenuButton>
      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        {onSelect && (
          <MenuItem>
            <a
              onClick={onSelect}
              className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
            >
              Seleccionar
            </a>
          </MenuItem>
        )}
        {onBreakFast && (
          <MenuItem>
            <a
              onClick={onBreakFast}
              className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
            >
              {t("nutrition-wizard.views.breakfast")}
            </a>
          </MenuItem>
        )}
        {onMediaMana && (
          <MenuItem>
            <a
              onClick={onMediaMana}
              className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
            >
              {t("user.views.media_manana")}
            </a>
          </MenuItem>
        )}
        {onLunch && (
          <MenuItem>
            <a
              onClick={onLunch}
              className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
            >
              {t("nutrition-wizard.views.lunch")}
            </a>
          </MenuItem>
        )}
        {onSnack && (
          <MenuItem>
            <a
              onClick={onSnack}
              className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
            >
              {t("nutrition-wizard.views.snack")}
            </a>
          </MenuItem>
        )}
        {onDinner && (
          <MenuItem>
            <a
              onClick={onDinner}
              className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
            >
              {t("nutrition-wizard.views.dinner")}
            </a>
          </MenuItem>
        )}
        {onPoscena && (
          <MenuItem>
            <a
              onClick={onPoscena}
              className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
            >
              {t("user.views.posCena")}
            </a>
          </MenuItem>
        )}
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenuNutritionDialog;
